import * as stylex from '@stylexjs/stylex';
import '~styles/theme.stylex';
import { colors, radius, font } from '~styles/theme.stylex';
export const styles = {
  icon: {
    color: "x1gonuu0",
    $$css: true
  },
  chips: {
    display: "x78zum5",
    flexWrap: "x1a02dak",
    gap: "x13z6uf9",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  chip: {
    display: "x3nfvp2",
    alignItems: "x6s0dn4",
    gap: "xpj7pl4",
    rowGap: null,
    columnGap: null,
    borderRadius: "x1w8o7ox",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    backgroundColor: "xs3zovl",
    color: "xtt1gjl",
    paddingBlock: "x1bilvtl",
    paddingTop: null,
    paddingBottom: null,
    paddingInline: "x1ryrjj2",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    fontSize: "x1dcheo9",
    fontWeight: "xlr2uoh",
    $$css: true
  },
  check: {
    color: "x18yk8ih",
    flexShrink: "x2lah0s",
    $$css: true
  }
};